<style>
	@import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Device Management" title="Device Details" />
        
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            
                            <div class="row mb-3">
                                <div class="col-md-2 col-sm-12 mb-1">
                                    <h4 class="mb-0">IMEI - {{ deviceDetails.imei || 'Loading...' }}</h4>
                                </div>
                                <div class="col-md-2 col-sm-6 mb-1" v-if="canShowRenewal">
                                    <button class="btn btn-warning btn-sm float-end" type="button" data-original-title="test" @click="goToRenewal()">Renewal</button>
                                </div>
                                <div class="col-md-2 col-sm-6 mb-1" v-else>
                                    <button class="btn btn-warning btn-sm float-end disabled" type="button" data-original-title="test" disabled>Renewal</button>
                                </div>
                                <div class="col-md-2 col-sm-6 mb-1">
                                    <button class="btn btn-warning btn-sm float-end" type="button" data-original-title="test" @click="goToService('sim_change')">SIM Change</button>
                                </div>
                                <div class="col-md-2 col-sm-6 mb-1">
                                    <button class="btn btn-warning btn-sm float-end" type="button" data-original-title="test" @click="goToService('service')">Other Service</button>
                                </div>
                                <div class="col-md-2 col-sm-6 mb-1">
                                    <a
                                        href="#"
                                        class="btn btn-info float-end"
                                        @click.prevent="openSimDataModal"
                                        v-if="canShowSimData"
                                    >Show SIM Data</a>
                                </div>
                                <div class="col-md-2 col-sm-6 mb-1">
                                    <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end">
                                        <i class='bx bx-chevrons-left'></i> Back
                                    </a>
                                </div>
                            </div>

                            <!-- Vehicle and Device Details Row -->
                            <div class="row mb-4">
                                <!-- Vehicle Details Card -->
                                <div class="col-md-6">
                                    <div class="card border-primary">
                                        <div class="card-header bg-primary text-white">
                                            <h5 class="mb-0">
                                                <i class="icofont icofont-car me-2"></i>
                                                Vehicle Details
                                            </h5>
                                        </div>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-6">
                                                    <div class="detail-item mb-3">
                                                        <label class="fw-bold text-muted">Vehicle Number:</label>
                                                        <p class="mb-0 fs-5">{{ vehicleDetails.vehicle_no || 'N/A' }}</p>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="detail-item mb-3">
                                                        <label class="fw-bold text-muted">Owner Name:</label>
                                                        <p class="mb-0 fs-5">{{ vehicleDetails.owner_name || 'N/A' }}</p>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="detail-item mb-3">
                                                        <label class="fw-bold text-muted">Vehicle Type:</label>
                                                        <p class="mb-0 fs-5">{{ vehicleDetails.vehicle_type || 'N/A' }}</p>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="detail-item mb-3">
                                                        <label class="fw-bold text-muted">Mobile Number:</label>
                                                        <p class="mb-0 fs-5">{{ vehicleDetails.mobile || 'N/A' }}</p>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="detail-item mb-3">
                                                        <label class="fw-bold text-muted">Expiry Date:</label>
                                                        <p class="mb-0 fs-5">{{ vehicleDetails.expiry ? $filters.formatDate(vehicleDetails.expiry) : 'N/A' }}</p>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="detail-item mb-3">
                                                        <label class="fw-bold text-muted">Status:</label>
                                                        <span class="badge" :class="vehicleStatus === 'Active' ? 'bg-success' : vehicleStatus === 'Expired' ? 'bg-danger' : 'bg-secondary'">
                                                            {{ vehicleStatus }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="col-12">
                                                    <div class="detail-item mb-3">
                                                        <label class="fw-bold text-muted">Dealer:</label>
                                                        <p class="mb-0 fs-5">{{ deviceDetails.dealer_name || 'N/A' }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Device Details Card -->
                                <div class="col-md-6">
                                    <div class="card border-info">
                                        <div class="card-header bg-info text-white">
                                            <h5 class="mb-0">
                                                <i class="icofont icofont-company me-2"></i>
                                                Device Details
                                            </h5>
                                        </div>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-6">
                                                    <div class="detail-item mb-3">
                                                        <label class="fw-bold text-muted">IMEI:</label>
                                                        <p class="mb-0 fs-5">{{ deviceDetails.imei || 'N/A' }}</p>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="detail-item mb-3">
                                                        <label class="fw-bold text-muted">ICCID:</label>
                                                        <p class="mb-0 fs-5">{{ deviceDetails.iccid || 'N/A' }}</p>
                                                    </div>
                                                </div>
                                                
                                                <div class="col-4">
                                                    <div class="detail-item mb-3">
                                                        <label class="fw-bold text-muted">SIM Number 1:</label>
                                                        <p class="mb-0 fs-5">{{ deviceDetails.sim_number_1 || 'N/A' }}</p>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="detail-item mb-3">
                                                        <label class="fw-bold text-muted">SIM Number 2:</label>
                                                        <p class="mb-0 fs-5">{{ deviceDetails.sim_number_2 || 'N/A' }}</p>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="detail-item mb-3">
                                                        <label class="fw-bold text-muted">SIM Provider:</label>
                                                        <p class="mb-0 fs-5">{{ deviceDetails.sim_provider || 'N/A' }}</p>
                                                    </div>
                                                </div>

                                                <div class="col-4">
                                                    <div class="detail-item mb-3">
                                                        <label class="fw-bold text-muted">Activation Date:</label>
                                                        <p class="mb-0 fs-5">{{ deviceDetails.activation_date ? $filters.formatDate(deviceDetails.activation_date) : 'N/A' }}</p>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="detail-item mb-3">
                                                        <label class="fw-bold text-muted">Power:</label><br>
                                                        <span class="badge" :class="deviceDetails.power === 1 ? 'bg-success' : deviceDetails.power === 0 ? 'bg-danger' : 'bg-secondary'">
                                                            {{ deviceDetails.power === 1 ? 'On' : deviceDetails.power === 0 ? 'Off' : 'N/A' }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="detail-item mb-3">
                                                        <label class="fw-bold text-muted">Ignition:</label><br>
                                                        <span class="badge" :class="deviceDetails.ignition === 1 ? 'bg-success' : deviceDetails.ignition === 0 ? 'bg-danger' : 'bg-secondary'">
                                                            {{ deviceDetails.ignition === 1 ? 'On' : deviceDetails.ignition === 0 ? 'Off' : 'N/A' }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="detail-item mb-3">
                                                        <label class="fw-bold text-muted">Last Updated:</label>
                                                        <p class="mb-0 fs-5">{{ deviceDetails.last_updated ? $filters.formatDateTime(deviceDetails.last_updated) : 'N/A' }}</p>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="detail-item mb-3">
                                                        <label class="fw-bold text-muted">Device Model:</label>
                                                        <p class="mb-0 fs-5">{{ deviceDetails.device_model || 'N/A' }}</p>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="detail-item mb-3">
                                                        <label class="fw-bold text-muted">Gnss Fix:</label><br>
                                                        <span class="badge" :class="deviceDetails.gnss_fix === true ? 'bg-success' : deviceDetails.gnss_fix === false ? 'bg-danger' : 'bg-secondary'">
                                                            {{ deviceDetails.gnss_fix === true ? 'Fix' : deviceDetails.gnss_fix === false ? 'Not Fix' : 'Not Fix' }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Device History Section -->
                            <div class="row mt-4">
                                <div class="col-12">
                                    <div class="card border-primary">
                                        <div class="card-header bg-primary text-white">
                                            <h5 class="mb-0">
                                                <i class="icofont icofont-history me-2"></i>
                                                Device History
                                            </h5>
                                        </div>
                                        <div class="card-body">
                                            <div class="table-responsive">
                                                <table class="table table-bordered table-hover align-middle mb-0">
                                                    <thead class="table-light">
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Date</th>
                                                            <th>Type</th>
                                                            <th>Dealer</th>
                                                            <th>Remarks</th>
                                                            <th>Added By</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, idx) in deviceHistory" :key="item.id">
                                                            <td>{{ idx + 1 }}</td>
                                                            <td>{{ item.date ? $filters.formatDate(item.date) : '-' }}</td>
                                                            <td>
                                                                <span class="badge" :class="deviceHistoryTypeBadge(item.type)">
                                                                    {{ item.type_label || getDeviceHistoryType(item.type) }}
                                                                </span>
                                                            </td>
                                                            <td>{{ item.dealer_name || 'N/A' }}</td>
                                                            <td>{{ item.remarks || '-' }}</td>
                                                            <td>{{ item.added_user_name || 'N/A' }}</td>
                                                        </tr>
                                                        <tr v-if="deviceHistory.length === 0">
                                                            <td colspan="6" class="text-center text-muted">
                                                                <i class="icofont icofont-info-circle me-2"></i>
                                                                No device history found for this device.
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Complaint History Section -->
                            <div class="row mt-4">
                                <div class="col-12">
                                    <div class="card border-warning">
                                        <div class="card-header bg-warning text-dark">
                                            <h5 class="mb-0">
                                                <i class="icofont icofont-history me-2"></i>
                                                Complaint History
                                            </h5>
                                        </div>
                                        <div class="card-body">
                                            <div class="table-responsive">
                                                <table class="table table-bordered table-hover align-middle mb-0">
                                                    <thead class="table-light">
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Date</th>
                                                            <th>Type</th>
                                                            <th>Status</th>
                                                            <th>Remarks</th>
                                                            <th>Materials Used</th>
                                                            <th>Technician</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(complaint, idx) in complaintHistory" :key="complaint.id">
                                                            <td>{{ idx + 1 }}</td>
                                                            <td>{{ complaintDate(complaint) }}</td>
                                                            <td>{{ getServiceType(complaint.type) }}</td>
                                                            <td>{{ getStatus(complaint.status) }}</td>
                                                            <td>{{ complaint.remarks || 'N/A' }}</td>
                                                            <td>
                                                                <ul class="list-unstyled mb-0" v-if="complaint.materials && complaint.materials.length">
                                                                    <li v-for="material in complaint.materials" :key="material.id">
                                                                        {{ material.name }} - {{ material.quantity }}
                                                                    </li>
                                                                </ul>
                                                                <span v-else>N/A</span>
                                                            </td>
                                                            <td>{{ complaint.technician || 'N/A' }}</td>
                                                        </tr>
                                                        <tr v-if="complaintHistory.length === 0">
                                                            <td colspan="7" class="text-center text-muted">
                                                                <i class="icofont icofont-info-circle me-2"></i>
                                                                No complaint history found for this device.
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Tag Log Section -->
                            <div class="row mt-4">
                                <div class="col-12">
                                    <div class="card border-success">
                                        <div class="card-header bg-success text-white">
                                            <h5 class="mb-0">
                                                <i class="icofont icofont-tag me-2"></i>
                                                Tag Log
                                            </h5>
                                        </div>
                                        <div class="card-body">
                                            <div class="table-responsive">
                                                <table class="table table-bordered table-hover align-middle mb-0">
                                                    <thead class="table-light">
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Tag Date</th>
                                                            <th>Tagged By</th>
                                                            <th>Suraksha Mitra ID</th>
                                                            <th>Installation Certificate</th>
                                                            <th>Approval Certificate</th>
                                                            <th>Status</th>
                                                            <th>Created At</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(tag, idx) in tagData" :key="tag.id">
                                                            <td>{{ idx + 1 }}</td>
                                                            <td>{{ tag.tag_date ? $filters.formatDate(tag.tag_date) : 'N/A' }}</td>
                                                            <td>{{ tag.tag_by_name || 'N/A' }}</td>
                                                            <td>{{ tag.surakshamitra_id || 'N/A' }}</td>
                                                            <td>
                                                                <template v-if="tag.installation_certificate">
                                                                    <a
                                                                        :href="getCertificateUrl(tag.installation_certificate)"
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        class="btn btn-sm btn-outline-primary me-1 mb-1"
                                                                    >View</a>
                                                                    <a
                                                                        :href="getCertificateUrl(tag.installation_certificate)"
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        class="btn btn-sm btn-outline-secondary mb-1"
                                                                    >Download</a>
                                                                </template>
                                                                <span v-else class="text-muted">-</span>
                                                            </td>
                                                            <td>
                                                                <template v-if="tag.approval_certificate">
                                                                    <a
                                                                        :href="getCertificateUrl(tag.approval_certificate)"
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        class="btn btn-sm btn-outline-primary me-1 mb-1"
                                                                    >View</a>
                                                                    <a
                                                                        :href="getCertificateUrl(tag.approval_certificate)"
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        class="btn btn-sm btn-outline-secondary mb-1"
                                                                    >Download</a>
                                                                </template>
                                                                <span v-else class="text-muted">-</span>
                                                            </td>
                                                            <td>
                                                                <span class="badge" :class="tag.tag_status === 1 ? 'bg-success' : 'bg-secondary'">
                                                                    {{ getTagStatusLabel(tag.tag_status) }}
                                                                </span>
                                                            </td>
                                                            <td>{{ tag.converted_created_at || (tag.created_at ? $filters.formatDateTime(tag.created_at) : 'N/A') }}</td>
                                                        </tr>
                                                        <tr v-if="tagData.length === 0">
                                                            <td colspan="8" class="text-center text-muted">
                                                                <i class="icofont icofont-info-circle me-2"></i>
                                                                No tag log found for this device.
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-4">
                                <div class="col-12">
                                    <div class="card border-warning">
                                        <div class="card-header bg-secondary text-dark">
                                            <h5 class="mb-0">
                                                <i class="icofont icofont-history me-2"></i>
                                                Renewal History
                                            </h5>
                                        </div>
                                        <div class="card-body">
                                            <div class="table-responsive">
                                                <table class="table table-bordered table-hover align-middle mb-0">
                                                    <thead class="table-light">
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Log Date</th>
                                                            <th>Type</th>
                                                            <th>Status</th>
                                                            <th>Remarks</th>
                                                            <th>Staff</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(log, idx) in renewalLogs" :key="log.id">
                                                            <td>{{ idx + 1 }}</td>
                                                            <td>{{ log.log_date ? $filters.formatDateTime(log.log_date) : '-' }}</td>
                                                            <td>{{ logTypeLabel(log.type) }}</td>
                                                            <td>
                                                                <span v-if="log.status == 1" class="badge rounded-pill bg-warning">Attended</span>
                                                                <span v-else-if="log.status == 2" class="badge rounded-pill bg-success">Completed</span>
                                                                <span v-else class="badge rounded-pill bg-secondary">{{ log.status ?? '-' }}</span>
                                                            </td>
                                                            <td>{{ log.remarks || '-' }}</td>
                                                            <td>{{ log.staff_name || '-' }}</td>
                                                        </tr>
                                                        <tr v-if="renewalLogs.length === 0">
                                                            <td colspan="6" class="text-center text-muted">
                                                                <i class="icofont icofont-info-circle me-2"></i>
                                                                No renewal logs found for this device.
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
            <!-- Vodafone SIM data -->
            <div class="modal fade" id="simDataModalDeviceDetail" tabindex="-1" aria-labelledby="simDataModalDeviceDetailLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="simDataModalDeviceDetailLabel">Vodafone SIM Data</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div v-if="simDataModal.loading" class="text-center py-4">
                                <div class="spinner-border text-primary" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>
                            <div v-else-if="simDataModal.error" class="alert alert-danger mb-0">{{ simDataModal.error }}</div>
                            <div v-else-if="simDataModal.details" class="table-responsive">
                                <table class="table table-bordered mb-0">
                                    <tbody>
                                        <tr>
                                            <th style="width: 35%">ICCID</th>
                                            <td>{{ simDataModal.details.iccid || "—" }}</td>
                                        </tr>
                                        <tr>
                                            <th>Primary TSP Name</th>
                                            <td>{{ simDataModal.details.Primary_TSP_Name || "—" }}</td>
                                        </tr>
                                        <tr>
                                            <th>Fallback TSP Name</th>
                                            <td>{{ simDataModal.details.Fallback_TSP_Name || "—" }}</td>
                                        </tr>
                                        <tr>
                                            <th>Primary TSP MSISDN</th>
                                            <td>{{ simDataModal.details.Primary_TSP_MSISDN || "—" }}</td>
                                        </tr>
                                        <tr>
                                            <th>Fallback TSP MSISDN</th>
                                            <td>{{ simDataModal.details.Fallback_TSP_MSISDN || "—" }}</td>
                                        </tr>
                                        <tr>
                                            <th>Primary TSP Validity</th>
                                            <td>{{ simDataModal.details.Primary_TSP_Validity ? $filters.formatDate(simDataModal.details.Primary_TSP_Validity) : "—" }}</td>
                                        </tr>
                                        <tr>
                                            <th>Fallback TSP Validity</th>
                                            <td>{{ simDataModal.details.Fallback_TSP_Validity ? $filters.formatDate(simDataModal.details.Fallback_TSP_Validity) : "—" }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
import { Modal } from "bootstrap"

export default {
    name: "DeviceDetail",
    
    data() {
        return {
            imei: null,
            deviceDetails: {},
            vehicleDetails: {},
            complaintHistory: [],
            renewalLogs: [],
            tagData: [],
            deviceHistory: [],
            loading: true,
            role_id: null,
            simDataModalInstance: null,
            simDataModal: {
                iccid: "",
                loading: false,
                error: "",
                details: null,
            },
        };
    },
    mounted() {
        // Use route param or query (depending on how you configured)
        this.imei = this.$route.params.imei || this.$route.query.imei;
        const simDataEl = document.getElementById("simDataModalDeviceDetail");
        if (simDataEl) {
            this.simDataModalInstance = new Modal(simDataEl);
        }

        if (this.imei) {
            this.getToken();
            this.fetchDeviceDetails();
            this.fetchDeviceHistory();
        } else {
            this.$swal("Error", "IMEI not provided in route", "error");
            this.$router.push({ name: "device_management" });
        }
    },
    computed: {
        canShowRenewal() {
            return this.role_id === 6 || this.role_id === 11 || this.role_id === 13;
        },
        canShowSimData() {
            return this.isVodafoneSimProvider(this.deviceDetails?.sim_provider) && String(this.deviceDetails?.iccid || "").trim() !== "";
        },
        vehicleStatus() {
            const expiry = this.vehicleDetails.expiry;
            if (!expiry) return 'N/A';
            const expiryDate = new Date(expiry);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            expiryDate.setHours(0, 0, 0, 0);
            return expiryDate < today ? 'Expired' : 'Active';
        }
    },
    methods: {

        getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

       async fetchDeviceDetails() {
            this.loading = true;

            try {
                const params = new URLSearchParams({
                    imei: this.imei,
                }).toString();

                const url = `/staffs/deviceDetails?${params}`;

                const res = await this.$axios.get(url, {
                    headers: { Authorization: `Bearer ${this.token}` },
                });

                if (res.data.status === "true") {
                    const data = res.data.data;

                    // Extract role_id from user_data
                    this.role_id = data.user_data?.role_id || null;

                    this.vehicleDetails = {
                        vehicle_no: data.vehicle_details.vehicle_number,
                        owner_name: data.vehicle_details.name || data.vehicle_details.user_name,
                        vehicle_type: data.vehicle_details.vehicle_type,
                        expiry: data.vehicle_details.device_expiry,
                        status: "Active",
                        mobile: data.vehicle_details.mobile,
                        dealer_name: data.vehicle_details.dealer_name,
                    };

                    this.deviceDetails = {
                        imei: data.device_details.imei,
                        iccid: data.device_details.iccid,
                        sim_number_1: data.device_details.primary_mobile_number,
                        sim_number_2: data.device_details.secondary_mobile_number,
                        activation_date: data.device_details.sim_activation_date,
                        power: data.device_details.power,
                        ignition: data.device_details.ignition,
                        last_updated: data.device_details.lastupdate,
                        sim_provider: data.device_details.sim_provider || data.device_details.network_provider,
                        dealer_name: data.vehicle_details.dealer_name,
                        device_model: data.device_details.device_model,
                        gnss_fix: data.device_details.gnss_fix,
                    };

                    this.complaintHistory = (data.complaint_logs || []).map((c) => {
                        const logCreatedAt = c.log_created_at || c.created_at || null;
                        return {
                            id: c.id,
                            date: logCreatedAt,
                            type: c.service_type,
                            status: c.status,
                            remarks: c.remarks,
                            log_created_at: logCreatedAt,
                            materials: (c.materials_used || []).map((m) => ({
                                name: m.raw_material_name,
                                quantity: m.quantity,
                            })),
                            technician: c.staff_name || "N/A",
                        };
                    });

                    this.renewalLogs = (data.renewal_logs || []).map((l) => ({
                        id: l.id,
                        renewal_id: l.renewal_id,
                        type: l.type,
                        status: l.status,
                        remarks: l.remarks,
                        staff_name: l.staff_name,
                        log_date: l.log_date || l.created_at || null,
                    }));

                    this.tagData = Array.isArray(data.tag_data) ? data.tag_data : [];
                    
                } else {
                    this.$swal("Error", res.data.message || "Failed to fetch details", "error");
                }
            } catch (error) {
                console.error("Fetch error:", error);
                const message =
                    error.response?.data?.message ||
                    "An error occurred while fetching device details.";
                this.$swal("Error", message, "error");
            } finally {
                this.loading = false;
            }
        },

        async fetchDeviceHistory() {
            try {
                const params = new URLSearchParams({
                    imei: this.imei,
                }).toString();

                const res = await this.$axios.get(`/staffs/getDeviceHistory?${params}`, {
                    headers: { Authorization: `Bearer ${this.token}` },
                });

                if (res.data.status === "true" || res.data.status === true) {
                    this.deviceHistory = Array.isArray(res.data.data?.history)
                        ? res.data.data.history
                        : [];
                } else {
                    this.deviceHistory = [];
                }
            } catch (error) {
                console.error("Device history fetch error:", error);
                this.deviceHistory = [];
            }
        },

        getDeviceHistoryType(type) {
            const map = {
                1: "Normal",
                2: "Replacement",
                3: "Buy back",
                4: "Old Dealer",
                5: "New Dealer",
                6: "Device Removal",
                7: "Device Expiry",
            };
            return map[type] != null ? map[type] : "Unknown";
        },

        deviceHistoryTypeBadge(type) {
            const map = {
                1: "bg-secondary",
                2: "bg-info",
                3: "bg-warning text-dark",
                4: "bg-danger",
                5: "bg-success",
                6: "bg-dark",
                7: "bg-primary",
            };
            return map[type] || "bg-secondary";
        },

        complaintDate(complaint) {
            const value = complaint?.log_created_at || complaint?.date || null;
            if (!value) return "-";
            return this.$filters.formatDateTime(value);
        },

        getServiceType(type) {
        
             switch (type) {
                case 1: return "SIM Change";
                case 2: return "Repair";
                case 3: return "Replacement";
                case 4: return "No Data";
                case 5: return "Tracking Issue";
                case 6: return "Hardware Issue";
                case 7: return "Software Issue";
                case 8: return "Alert Fail";
                case 9: return "Other";
                case 10: return "Renewal Replacement";
                default: return "Unknown";
            }
        },
        getStatus(status) {
            switch (status) {
                case 1: return "Pending";
                case 2: return "Ongoing";
                case 3: return "Completed";
                case 4: return "To Vendor";
                case 5: return "Component Replacement";
                case 6: return "SIM Change";
                case 7: return "Device Replaced";
                case 8: return "Payment";
                case 9: return "Revoke";
                case 10: return "Update";
                default: return "Unknown";
            }
        },

        logTypeLabel(type) {
            const map = {
                1: "Renewal",
				2: "Enquiry",
				3: "Recharge Request",
				4: "Assign Recharge",
				5: "Recharge Completed",
				6: "Customer Info",
				7: "Dealer Info",
				8: "Payment Received",
				9: "To Safe Custody",
				10: "RechargeRequest Viewed",
				11: "Extension",
				12: "Replacement",
				13: "Revoke",
				14: "Update",
				15: "Topup Request",
				16: "Topup Completed",
            };
            return map[type] != null ? map[type] : (type != null ? "Type " + type : "-");
        },

        getTagStatusLabel(status) {
            if (status === 1) return "Tagged";
            if (status === 2) return "Untagged";
            return status != null ? String(status) : "N/A";
        },

        getCertificateUrl(path) {
            if (!path) return "";
            if (String(path).startsWith("http://") || String(path).startsWith("https://")) {
                return path;
            }
            return this.$image_url + path;
        },

        goToRenewal() {
            // Redirect to all devices page with IMEI selection
            this.$router.push({ name: 'all_devices', query: { imei: this.deviceDetails.imei } });
        },

        goToService(serviceType) {
            // Redirect to add complaint page with IMEI and service type
            this.$router.push({ 
                name: 'add_complaint', 
                query: { 
                    imei: this.deviceDetails.imei,
                    service_type: serviceType
                } 
            });
        },

        isVodafoneSimProvider(provider) {
            const raw = String(provider || "").trim().toLowerCase();
            if (!raw) return false;
            const normalized = raw.replace(/\s*\+\s*/g, " ").replace(/\s+/g, " ").trim();
            if (normalized === "vodafone") return true;
            return normalized.includes("vodafone") && normalized.includes("idea");
        },

        openSimDataModal() {
            const iccid = String(this.deviceDetails?.iccid || "").trim();
            if (!iccid) {
                this.$swal("", "ICCID not available for this device", "error");
                return;
            }
            this.getToken();
            this.simDataModal.iccid = iccid;
            this.simDataModal.loading = true;
            this.simDataModal.error = "";
            this.simDataModal.details = null;
            if (this.simDataModalInstance) this.simDataModalInstance.show();
            this.$axios
                .get("/staffs/iccidDetails", {
                    params: { iccid },
                    headers: { Authorization: "Bearer " + this.token },
                })
                .then((res) => {
                    const ok = res.data?.status === true || res.data?.status === "true";
                    if (ok && res.data?.data) {
                        this.simDataModal.details = res.data.data;
                    } else {
                        this.simDataModal.error = res.data?.message || "Failed to fetch SIM data";
                    }
                })
                .catch((err) => {
                    this.simDataModal.error = err?.response?.data?.message || "Something went wrong";
                })
                .finally(() => {
                    this.simDataModal.loading = false;
                });
        },

    }
};
</script>

<style scoped>
.detail-item {
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;
}

.detail-item:last-child {
    border-bottom: none;
}

.detail-item label {
    font-size: 0.875rem;
    margin-bottom: 5px;
}

.card {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    transition: box-shadow 0.15s ease-in-out;
}

.card:hover {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.table th {
    font-weight: 600;
    background-color: #f8f9fa;
}

.badge {
    font-size: 0.75rem;
}
</style> 